/**
 * Shared horizontal inset for Components page content + inventory header breadcrumb.
 * Keep these in sync so hero, search, filters, and cards share one left edge.
 */
export const COMPONENTS_PAGE_INSET =
  'px-8 max-[1400px]:px-6 max-lg:px-5 max-md:px-4 max-[420px]:px-3';

/** Left/right gutters — mirror COMPONENTS_PAGE_INSET for TopNavBar alignment. */
export const COMPONENTS_PAGE_INSET_LEFT =
  'pl-8 max-[1400px]:pl-6 max-lg:pl-5 max-md:pl-4 max-[420px]:pl-3';

export const COMPONENTS_PAGE_INSET_RIGHT =
  'pr-8 max-[1400px]:pr-6 max-lg:pr-5 max-md:pr-4 max-[420px]:pr-3';

export const COMPONENTS_PAGE_TOP = 'pt-5 max-md:pt-4 max-[420px]:pt-3';

export const COMPONENTS_PAGE_BOTTOM = 'pb-8 max-md:pb-6';

/** Full-width content rail — padding defines gutters. */
export const COMPONENTS_PAGE_RAIL = 'box-border w-full min-w-0 max-w-full';

/** Fixed desktop search geometry (~35–40% of content, mock-aligned). */
export const COMPONENTS_SEARCH_WIDTH =
  'w-full min-w-0 max-w-full min-[900px]:w-[28rem] min-[900px]:max-w-[28rem] min-[900px]:shrink-0';

/**
 * Card grid — 1 col mobile; auto-fill tablet; 3 cols laptop; fluid on very wide screens.
 */
export const COMPONENTS_GRID =
  'grid w-full min-w-0 grid-cols-1 items-stretch justify-start gap-4 sm:gap-4 min-[640px]:grid-cols-[repeat(auto-fill,minmax(min(100%,260px),1fr))] min-[1024px]:grid-cols-3 min-[1600px]:grid-cols-[repeat(auto-fill,minmax(min(100%,320px),1fr))]';

/** Card shell — equal height in grid; content zones use fixed min-heights inside. */
export const COMPONENTS_CARD_SHELL =
  'box-border h-full min-h-[15.5rem] w-full max-w-full';

/** Viewport-bounded height for inventory file explorer + code pane (desktop split). */
export const INVENTORY_EXPLORER_HEIGHT =
  'min-[960px]:h-[max(36rem,calc(100vh-var(--workspace-header-height,3.31rem)-7rem))] min-[960px]:max-h-[max(36rem,calc(100vh-var(--workspace-header-height,3.31rem)-7rem))]';
